<template>
  <div class="card mx-0 mt-2 mb-2">
    <div class="card-header">
      <div class="row">
        <div class="col d-flex align-items-center pr-0 pl-2">
          <h4 class="m-0">Additional {{ type }} Request</h4>
        </div>
        <div class="col-3 text-right pl-0 pr-2">
          <button
            data-toggle="tooltip"
            data-placement="top"
            :title="`Delete ${type} Request`"
            class="btn btn-outline-white px-2 py-1"
            type="button"
            @click="deleteRequest"
          >
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="form-row">
        <div class="col">
          <h5 class="py-2 border-bottom mb-2">
            <strong>{{ type }} Info</strong>
          </h5>
        </div>
      </div>
      <div class="form-row">
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label class="form-control-wrap mb-1">Start Date</label>
            <div class="form-control-wrap form-datepicker">
              <v-datepicker
                type="text"
                v-model="form.start_date"
                :name="`${inputName}[${index}][start_date]`"
                autocomplete="off"
                class="form-control datepicker"
                pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                :options="dateConfig({ autofill: 'start' })"
              ></v-datepicker>
              <span class="form-control-date-custom"></span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label class="form-control-wrap mb-1">End Date</label>
            <div class="form-control-wrap form-datepicker">
              <v-datepicker
                type="text"
                v-model="form.end_date"
                :name="`${inputName}[${index}][end_date]`"
                autocomplete="off"
                class="form-control datepicker"
                pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                :options="dateConfig({ autofill: 'end' })"
              ></v-datepicker>
              <span class="form-control-date-custom"></span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label class="form-control-wrap">What is it for?</label>
            <div class="form-control-wrap">
              <v-text
                v-model="form.what_for"
                class="form-control alphanumeric-field"
                autocomplete="off"
                :name="`${inputName}[${index}][what_for]`"
              ></v-text>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 mb-3">
          <div class="form-group">
            <label class="form-control-wrap">How much is it?</label>
            <div class="form-control-wrap form-control-currency">
              <i class="fas fa-dollar-sign"></i>
              <v-currency
                :is-blank="false"
                type="text"
                class="form-control text-right"
                :name="`${inputName}[${index}][amount]`"
                v-model="form.amount"
              ></v-currency>
            </div>
          </div>
        </div>
        <div class="col-12 mb-3">
          <div class="form-group text-sm">
            <label class="form-control-wrap">{{ isInvoiceRequest ? "Invoice to" : "Who is it being paid to?" }}</label>
            <v-select
              v-if="isInvoiceRequest"
              v-model="form.invoiced_to_id"
              :name="`${inputName}[${index}][invoiced_to_id]`"
              :options="receiverOptions"
            >
            </v-select>
            <v-select v-else v-model="form.payable_to_id" :name="`${inputName}[${index}][payable_to_id]`" :options="receiverOptions"> </v-select>
          </div>
        </div>
        <div class="col-12 mb-3">
          <div class="form-group">
            <label class="form-control-wrap">{{ receiverLabel }}</label>
            <div class="form-control-wrap">
              <v-text
                v-if="isInvoiceRequest"
                v-model="form.invoiced_to"
                class="form-control alphanumeric-field"
                autocomplete="off"
                :name="`${inputName}[${index}][invoiced_to]`"
              ></v-text>
              <v-text
                v-else
                v-model="form.payable_to"
                class="form-control alphanumeric-field"
                autocomplete="off"
                :name="`${inputName}[${index}][payable_to]`"
              ></v-text>
            </div>
          </div>
        </div>
        <div class="col-12 mb-3" v-if="!isInvoiceRequest">
          <div class="form-group text-sm">
            <label class="form-control-wrap">Payment Method</label>
            <v-select v-model="form.payment_method_id" :name="`${inputName}[${index}][payment_method_id]`" :options="paymentMethods"> </v-select>
          </div>
        </div>
        <div class="col-12" :class="{ 'mb-3': isInvoiceRequest }">
          <div class="form-group">
            <label class="form-control-wrap">Notes</label>
            <div class="form-control-wrap">
              <textarea
                spellcheck="true"
                :name="`${inputName}[${index}][notes]`"
                :rows="isInvoiceRequest ? 8 : 6"
                max-height="10"
                class="form-control alphanumeric-field ruled-textarea show-resize"
                v-model="form.notes"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <input type="hidden" :name="`${inputName}[${index}][id]`" v-model="form.id" />
    </div>

    <div class="card-footer bg-secondary"></div>
  </div>
</template>
<script>
export default {
  props: ["item", "data", "index", "isInvoiceRequest"],
  data() {
    return {
      form: {
        id: this.item ? this.item.id : 0,
        start_date: this.item ? this.item.start_date : "",
        end_date: this.item ? this.item.end_date : "",
        what_for: this.item ? this.item.what_for : "",
        amount: this.item ? this.item.amount : 0,
        invoiced_to_id: this.item ? this.item.invoiced_to_id : 1,
        invoiced_to: this.item ? this.item.invoiced_to : "",
        payable_to_id: this.item ? this.item.payable_to_id : 1,
        payable_to: this.item ? this.item.payable_to : "",
        payment_method_id: this.item ? this.item.payment_method_id : 1,
        notes: this.item && this.item.notes ? this.item.notes : ""
      }
    };
  },
  watch: {
    "form.invoiced_to_id"(val) {
      if (this.item && this.item.invoiced_to == this.form.invoiced_to && this.item.invoiced_to_id == val) return;

      switch (val) {
        case "1":
        case 1:
          this.form.invoiced_to = this.data.policyholder;
          break;
        case "2":
        case 2:
          this.form.invoiced_to = this.data.public_adjuster;
          break;
        case "3":
        case 3:
          this.form.invoiced_to = this.data.insurance_company;
          break;
        default:
          this.form.invoiced_to = "";
          break;
      }
    },
    "form.payable_to_id"(val, oldVal) {
      if (val == oldVal || (this.item && this.item.payable_to == this.form.payable_to && this.item.payable_to_id == val)) return;

      switch (val) {
        case "1":
        case 1:
          this.form.payable_to = this.data.policyholder;
          break;
        case "2":
        case 2:
          this.form.payable_to = this.data.landlord_name;
          break;
        case "3":
        case 3:
          this.form.payable_to = this.data.agent_name;
          break;
        default:
          this.form.payable_to = "";
          break;
      }
    }
  },
  computed: {
    type() {
      return this.isInvoiceRequest ? "Invoice" : "Payment";
    },
    inputName() {
      return this.isInvoiceRequest ? "invoice_requests" : "payment_requests";
    },
    paymentMethods() {
      return app_data.options.payment_methods;
    },
    receiverOptions() {
      return this.isInvoiceRequest ? app_data.options.invoiceable_to_list : app_data.options.payable_to_list;
    },
    receiverOption() {
      const id = this.isInvoiceRequest ? this.form.invoiced_to_id : this.form.payable_to_id;
      const option = this.receiverOptions.find(opt => opt.id == id);
      return option;
    },
    receiverLabel() {
      if (!this.receiverOption) return "";

      if (["Other"].includes(this.receiverOption.text)) return `${this.receiverOption.text} (Desc)`;

      return `${this.receiverOption.text} Name`;
    }
  },
  methods: {
    dateConfig(options = {}) {
      return this.$parent.dateConfig(options);
    },
    deleteRequest() {
      const key = this.isInvoiceRequest ? "invoiceRequests" : "paymentRequests";
      this.$parent.deleteRequest(key, this.index);
      $(".tooltip.show").remove();
    }
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/reports/additional-status-request.vue